import auth from "../../services/auth";
import notifications from "../../services/notifications";
import _ from "lodash";

export default {
  namespaced: true,
  state: {
    loading: false,
    errors: null,
    confirmedEmail: "",
    planList: [],
    registrationData: null,
    isBypassPayment: false
  },
  mutations: {
    loading(state, value = true) {
      state.loading = value;
    },
    errors(state, errors) {
      state.errors = errors;
    },
    resetErrors(state) {
      state.errors = null;
    },
    confirmedEmail(state, confirmedEmail) {
      state.confirmedEmail = confirmedEmail;
    },
    setPlanList(state, list) {
      state.planList = list;
    },
    setRegistrationData(state, payload) {
      state.registrationData = payload;
    },
    setIsBypassPayment(state, status) {
      state.isBypassPayment = status;
    }
  },
  getters: {
    planList: state => state.planList,
    authErrors: state => state.errors,
    isBypassPayment: state => state.isBypassPayment
  },
  actions: {
    async resetErrors({ commit }) {
      commit("resetErrors");
    },
    async registerUser({ commit }, payload) {
      commit("loading", true);
      commit("resetErrors");

      try {
        await auth.registerUser(payload);
        commit("confirmedEmail", payload.email);
      } catch (errors) {
        const { message } = errors.errors;
        if (message) notifications.warning(message);
        else notifications.warning("Oops! Cannot register right now.")

        commit("errors", errors.errors);
      } finally {
        commit("loading", false);
      }
    },
    async getPlanList({ commit }, planType) {
      commit("loading", true);
      commit("resetErrors");

      try {
        const { data } = await auth.getPlanList(planType);

        commit("setPlanList", data);
      } catch (errors) {
        commit("errors", errors);
      } finally {
        commit("loading", false);
      }
    },
    async verifyEmail({ commit }, payload) {
      commit("loading", true);
      commit("resetErrors");

      try {
        await auth.verifyEmail(payload);
      } catch (errors) {
        commit("errors", errors);
      } finally {
        commit("loading", false);
      }
    },
    async registerValidate({ commit }, payload) {
      commit("loading", true);
      commit("resetErrors");

      try {
        const requiredPayload = _.omit(
          payload, 
          [
            "confirm_email",
            "terms_and_condition",
            "billing_address",
            "referral_code"
          ]
        );

        const { data } = await auth.registerValidate({ ...requiredPayload });

        commit("setRegistrationData", payload);
        if (data.is_bypass_payment) commit("setIsBypassPayment", data.is_bypass_payment);
      } catch (errors) {
        const { message } = errors.errors;

        if (message) notifications.warning(message);

        commit("errors", errors.errors);
      } finally {
        commit("loading", false);
      }
    },
  }
};
